import { styled } from '@linaria/react'
import React, { type ComponentProps, type FC, type ReactNode } from 'react'
import { Progress } from '../ui/Progress'
import { BoxShareButton } from './BoxShareButton'
import { BoxStatusBar, type TagType } from '../ui/BoxStatusBar'
import { RouterLink } from '../ui/RouterLink'
import { colors } from '../styles/colors'
import { ModerationBadge } from '../ui/ModerationBadge'
const ProgressBarHeightPx = 4

export const BoxImage: FC<{
  boxId: number
  expiration: ReactNode
  hasYourVote?: boolean
  imgSrc?: string
  isExpired: boolean
  isUnderModeration?: boolean
  onRewardClaim?: () => void
  progressPercentage?: number
  status?: ComponentProps<typeof BoxStatusBar>['status']
  tags: Record<TagType, boolean>
}> = ({
  boxId,
  expiration,
  hasYourVote,
  imgSrc,
  isExpired,
  isUnderModeration,
  onRewardClaim,
  progressPercentage,
  status,
  tags,
}) => {
  return (
    <ImageContainer isExpired={isExpired}>
      <StyledShareButton boxId={boxId} />

      <RouterLink to={`/box/${boxId}`} state={{ source: 'feed' }}>
        <img
          src={imgSrc ? imgSrc : '/placeholder.webp'}
          alt="box-image"
          height={200}
          width={400}
        />
      </RouterLink>
      <GradientOverlay />
      {isUnderModeration && <StyledModerationBadge />}
      {progressPercentage !== undefined && (
        <ProgressOverlay>
          <Progress
            percentage={progressPercentage}
            height={ProgressBarHeightPx}
          />
        </ProgressOverlay>
      )}
      <StyledStatusBar
        expiration={expiration}
        hasYourVote={hasYourVote}
        onRewardClaim={onRewardClaim}
        status={status}
        tags={tags}
      />
    </ImageContainer>
  )
}

const StyledStatusBar = styled(BoxStatusBar)`
  position: absolute;
  padding: 0 8px;
  left: 0;
  right: 0;
  bottom: calc(${ProgressBarHeightPx}px + 8px);
  z-index: 1;
`

const GradientOverlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 80px;
  background: linear-gradient(
    180deg,
    ${colors.overlayTransparent} 0%,
    ${colors.overlayDark} 100%
  );
  pointer-events: none;
`

const ImageContainer = styled.div<{ isExpired: boolean }>`
  position: relative;
  width: 100%;
  aspect-ratio: 360 / 150;
  border-radius: 24px 24px 0 0;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    opacity: ${({ isExpired }) => (isExpired ? 0.5 : 1)};
  }
`

const StyledShareButton = styled(BoxShareButton)`
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 1;
`

const StyledModerationBadge = styled(ModerationBadge)`
  position: absolute;
  bottom: calc(${ProgressBarHeightPx}px + 36px);
  left: 8px;
  z-index: 1;
`

const ProgressOverlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
`
